<template>
  <div class="main">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/books/studyTask'">学习任务</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">使用记录</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <TopBack :type="studyTask" :select="studySelect" v-show="false"></TopBack>
    <div class="content">
      <ul class="h-ul">
        <div class="list">
          <li class="h-li" v-for="(item,index) in list" :key="index">
          <div class="title">
            <div class="left">
              <span class="time">{{ format.format(item.createDate) }}</span>
              <span class="class-name"
                    v-if="item.taskType===1">已发布至 <span>{{ format.classListString(item.classList) }}</span></span>
              <span class="class-name"
                    v-if="item.taskType===2">已发布至 <span>{{ format.classListString(item.groupList) }}</span></span>
            </div>
            <div class="right" @click="useStudyRecommand(item.id,item)">使用</div>
          </div>
          <div class="s-t" v-html="item.content"></div>
          <ul class="act-ul" v-if="item.activityList&&item.activityList.length>0">
            <li class="act-li" v-for="(a,ai) in item.activityList" :key="ai">
              <div class="l">活动{{ format.number2Text(ai) }}</div>
              <div class="c">[{{ format.taskStyle(a.activityStyle) }}]</div>
              <!--              <div class="r" v-html="a.activityContent"></div>-->
              <rich-text-view
                  :key="new Date().getTime()"
                  class="r"
                  :content='a&&a.activityContent'
                  :images="a.imageList||[]"
                  :videos="a.videoList||[]"
                  :audios="a.audioList||[]"
              ></rich-text-view>
            </li>
          </ul>
        </li>
        </div>
        <a-empty v-if="list===null||list.length === 0">
          <span slot="description"> 暂无数据 </span>
        </a-empty>
      </ul>
      <div style="text-align:center;margin:15px 0px;" >
        <a-config-provider>
          <a-pagination :default-current="1" :page-size="pageSize" @change="handleListChange" :total='total'/>
        </a-config-provider>
      </div>
    </div>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
import format from '../../../../utils/format.js'
import TopBack from '../../../../components/TopBack.vue'
import RichTextView from '../../../../components/richTextView.vue'
import requestUrl from '@/utils/requestUrl.js'

export default {
  name: 'StudyTaskHistory',
  data() {
    return {
      format,
      defaultOpen: '公开',
      selectOpen: [{value: '公开', key: '1'}, {value: '私密', key: '2'}, {value: '仅班级可见', key: '3'}],
      list: [],
      total: 0,
      pageSize: 5,
      pageNum: 1,
      styleId: localStorage.getItem('styleId'),
      bookId: localStorage.getItem('syzg-bookId'),
      userId: this.$getUserInfo().id,
      access_token: this.$getUserInfo().access_token,
      studyTask: {
        name: '学习任务',
        route: 'StudyTask'
      },
      studySelect: {
        name: '使用记录',
        route: 'StudyTaskHistory'
      }
    }
  },
  components: {
    TopBack,
    RichTextView
  },
  mounted() {
    this.getTask()
  },
  methods: {
    handleListChange(current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getTask()
    },
    getTask() { // 获取备课历史
      const param = {
        bookId: this.bookId,
        styleId: this.styleId,
        teacherId: this.userId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.getTeacherTaskHistory, param).then(res => {
        if (res) {
          this.list = res.list
          this.total = res.total
          console.log(this.list)
        }
      })
    },
    useStudyRecommand(id, item) {
      if (item.activityList === null || item.activityList.length < 0) {
        this.$message.success('该任务下没有活动')
        return
      }
      const param = {
        id: id,
        teacherId: this.userId,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.useHistoryPublishTask, param).then(res => {
        if (res) {
          this.$message.success('使用成功')
          this.getTask()
          this.$router.push({name: 'StudyTask'})
        }
      })
    },
    handleChange(e) {
      console.log(e)
    }
  }
}
</script>

<style lang="less" scoped>
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.main {
  margin-left: -205px;

  .breadcrumb {
    width: 1240px;
    margin: 0px auto 20px auto;
  }

  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .content {
    height: calc(100vh - 185px);
    background: #FFFFFF;
    border-radius: 6px;
    width: 1240px;
    margin: 30px auto;

    .h-ul {
      padding: 10px;

      .list{
        overflow-y: auto;
        height: calc(100vh - 275px);
      }
      .h-li {
        // width: 1100px;
        // min-height: 226px;
        background: #F1F0F0;
        margin: 25px;
        padding: 20px;
        border-radius: 6px;

        .title {
          display: flex;

          .left {
            color: #867D7B;
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: calc(100% - 120px);

            .time {
            }

            .class-name {
              margin-left: 12px;
            }
          }

          .right {
            width: 80px;
            height: 24px;
            background: @primary-color;
            border-radius: 2px;
            line-height: 24px;
            color: #fff;
            text-align: center;
            margin-left: auto;
            cursor: pointer;
          }
        }

        .s-t {
          color: #000;
          margin: 10px 0;
          font-size: 16px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .act-ul {
          .act-li {
            display: flex;
            font-size: 14px;
            font-weight: 400;
            margin-top: 12px;

            .l {
              color: #867D7B;
              width: 42px;
            }

            .c {
              color: @primary-color;
              width: 42px;
              margin-left: 15px;
            }

            .r {
              color: #000;
              flex: 1;
              margin-left: 15px;
            }
          }
        }
      }
    }
  }
}

/deep/ .ant-list-pagination {
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
  background: #f1f0f0;
}

/deep/ .ant-list-pagination {
  margin-top: 0px;
}

/deep/ .ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

/deep/ .ant-list-split .ant-list-item {
  border-bottom: 10px solid #f1f0f0;
  padding: 20px 30px 20px 30px;
  min-height: 300px;
  overflow-y: auto;
}

/deep/ .ant-list-something-after-last-item
.ant-spin-container
> .ant-list-items
> .ant-list-item:last-child {
  border-bottom: 10px solid #f1f0f0;
}

/* table 样式 */
/deep/ table {
  border: 1px solid #ccc !important;
}

/deep/ th {
  border: 1px solid #ccc !important;
  min-height: 30px;
  height: 30px;
  text-align: center;
  background: #f3f1f2;
}

/deep/ td {
  border: 1px solid #ccc !important;
  min-height: 30px;
  height: 30px;
  text-align: center;
}
</style>
